/** Review structured values only: prose/photos never establish unmeasured facts. */
export function buyingInformationGaps(input: {
  attributes: readonly { slug: string; value: string | number | boolean }[];
  lengthMm?: number | null;
  widthMm?: number | null;
  heightMm?: number | null;
}): string[] {
  const has = (slugs: string[]) => input.attributes.some((attribute) => slugs.includes(attribute.slug) && (
    typeof attribute.value === "string" ? !!attribute.value.trim() && !/^(unknown|tbc|tbd|not confirmed)$/i.test(attribute.value.trim())
      : typeof attribute.value === "number" ? Number.isFinite(attribute.value) && attribute.value > 0 : attribute.value
  ));
  const gaps: string[] = [];
  if (!has(["belt-width", "fastening", "fit", "compatibility"])) gaps.push("fitting or compatibility");
  if (![input.lengthMm, input.widthMm, input.heightMm].some((value) => typeof value === "number" && Number.isFinite(value) && value > 0)) gaps.push("dimensions");
  if (!has(["material"])) gaps.push("material");
  if (!has(["condition"])) gaps.push("condition");
  if (!has(["included-items"])) gaps.push("included items");
  return gaps;
}
